'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import replacePlaceholders from 'labels/lib/replacePlaceholders'
import Image from 'next/image'

import styles from './ArticleInfo.module.scss'
import text from 'fukku/styles/texts.module.scss'

export interface ColorBullet {
	colorId?: string
	colorBulletImg?: string
	colorLabel?: string
}
interface ArticleInfoProps {
	readonly 'data-testid': string
	readonly name: string
	readonly reference: string
	readonly color?: ColorBullet
	readonly size: string
}

export function ArticleInfo({
	'data-testid': dataTestId,
	name,
	reference,
	size,
	color: { colorBulletImg, colorId, colorLabel } = {},
}: ArticleInfoProps) {
	const { t } = useLabels()

	return (
		<div className={styles.info}>
			<p data-testid={`${dataTestId}.name`} className={text.bodyM}>
				{name}
			</p>
			<p
				aria-label={replacePlaceholders(
					t('accessibility.productCard.reference.text'),
					{ 1: reference }
				)}
				data-testid={`${dataTestId}.reference`}
				className={styles.reference}
			>
				{t('myPurchases.details.itemRef.text')} {reference}
			</p>
			<div className={styles.colorSize}>
				{colorBulletImg && colorId && (
					<Image
						alt={colorLabel || colorId}
						className={styles.bullet}
						src={colorBulletImg}
						width={12}
						height={12}
						aria-label={replacePlaceholders(
							t('accessibility.productCard.colour.text'),
							{
								1: colorLabel || colorId,
							}
						)}
					/>
				)}
				<p
					data-testid={`${dataTestId}.size`}
					aria-label={replacePlaceholders(
						t('accessibility.productCard.size.text'),
						{
							1: size,
						}
					)}
				>
					{size}
				</p>
			</div>
		</div>
	)
}
